import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react';

import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '@/models';
import { message } from 'antd';
import cs from './index.module.scss';

import { LANG_LIST, LangCode, LangItem, CURRENCY_LIST, CurrencyItem } from '@/config/const';

export interface DropDownMenuItem {
  url: string;
  icon?: string;
  title: string;
  subTitle?: string;
  slot?: any;
}

interface Props extends React.ComponentProps<any> {
  data?: DropDownMenuItem[];
  onClick?: () => void;
}

const DropDownSettingMenu: React.FC<Props> = () => {
  const { push } = useHistory();
  const { account } = useStore();
  const { t } = useTranslation();
  const { lang, setLang, currency, setCurrency } = account;

  const [currentTab, setCurrentTab] = useState('lang');

  const handleClick = (url: string, onClick?: Function) => {
    if (/^[(http)|(https)]/.test(url)) {
      window.location.href = url;
    } else {
      push(url);
    }
    if (onClick) {
      onClick();
    }
  };
  const changeTab = type => {
    setCurrentTab(type);
  };
  const changeLang = item => {
    setLang(item as LangCode, false);
    console.log('changeLang', item);
    window.location.reload();
  };
  const changeRate = item => {
    setCurrency(item);
  };
  return (
    <div className={cs.container}>
      {/* <div className={cs.tab}>
        <span
          className={currentTab === 'lang' ? cs.tab_active : ''}
          onClick={() => {
            changeTab('lang');
          }}
        >
          {t('header.locale.title')}
        </span>
        <span
          className={currentTab === 'rate' ? cs.tab_active : ''}
          onClick={() => {
            changeTab('rate');
          }}
        >
          {t('header.rate.currency')}
        </span>
      </div>
      <div className={cs.line} /> */}
      <div className={cs.item}>
        {currentTab === 'lang' ? (
          <ul>
            {LANG_LIST.map(item => (
              <li
                key={item.value}
                className={lang === item.value ? cs.lang_active : ''}
                onClick={() => {
                  changeLang(item.value);
                }}
              >
                {item.label}
              </li>
            ))}
          </ul>
        ) : (
          <ul>
            {CURRENCY_LIST.map(item => (
              <li
                key={item.value}
                className={currency === item.value ? cs.lang_active : ''}
                onClick={() => {
                  changeRate(item.value);
                }}
              >
                {item.label}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default observer(DropDownSettingMenu);
